module.exports = __webpack_public_path__ + "static/media/hld_4.dbfa107b.png";